export function calculateRoi(data) {

  const socialFee = data.socialFee === 0 ? 1.00 : (1.0 + data.socialFee / 100.0);

  let vegetableTimeData = [];
  let totalTimeSavedPerDay = 0;
  let totalMoneySavedFirstYear = 0;
  let totalMoneySavedFirstQuarter = 0;
  let totalIncome = 0;

  data.vegetables.forEach(vegetable => {
    let incomeFirstYear = (vegetable.human - vegetable.machine) / 60
      * vegetable.quantityPerDay * data.workingDaysPerYear
      * data.labourCostPerHour * socialFee;
    let moneySavedFirstYear = incomeFirstYear;
    let moneySavedFirstQuarter = incomeFirstYear / 4;

    let timeSavedPerDay = (vegetable.human - vegetable.machine) / 60 * vegetable.quantityPerDay;

    vegetableTimeData.push({
      name: vegetable.name,
      incomeFirstYear: incomeFirstYear,
      moneySavedFirstYear: moneySavedFirstYear,
      moneySavedFirstQuarter: moneySavedFirstQuarter,
      timeSavedPerDay: timeSavedPerDay,
    });

    totalTimeSavedPerDay += timeSavedPerDay;
    totalMoneySavedFirstYear += moneySavedFirstYear;
    totalMoneySavedFirstQuarter += moneySavedFirstQuarter;
    totalIncome += incomeFirstYear;
  });

  let timeSaved;
  let timeSavedSuffix;
  if (totalTimeSavedPerDay * data.workingDaysPerWeek < 10) {
    timeSaved = totalTimeSavedPerDay * data.workingDaysPerWeek;
    timeSavedSuffix = 'Hours/ week';
  } else {
    timeSaved = totalTimeSavedPerDay * data.workingDaysPerYear / 12;
    timeSavedSuffix = 'Hours/ month';
  }

  let incomePerWeek = (totalIncome / 52);
  let weeksToPayMachine = data.listPrice / incomePerWeek;

  let paybackTime;
  let paybackTimeSuffix;
  if (weeksToPayMachine < 10) {
    paybackTime = weeksToPayMachine;
    paybackTimeSuffix = 'weeks';
  } else {
    paybackTime = weeksToPayMachine / 12;
    paybackTimeSuffix = 'months';
  }

  return {
    moneySavedFirstYear: totalMoneySavedFirstYear - data.listPrice,
    moneySavedFirstQuarter: totalMoneySavedFirstQuarter - data.listPrice,
    timeSaved,
    timeSavedSuffix,
    paybackTime,
    paybackTimeSuffix,
  };
}

export function isIntegrated() {
  return !!process.env.MIX_WP_BUILD;
}

export function formatMoney(number, prepend = '', append = '') {
  if (number < 0) {
    return '-';
  }

  number = Math.round(number);

  if (number > 999) {
    number = numberWithCommas(number);
  }

  return `${prepend}${number}${append}`;
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
